import Pricing from '../../assests/Pricing plans-pana 1.svg';
function LotalyProgram (){
return(
    <>
<div className='LotalyProgram text-center'>
<img src={Pricing} alt="" />
</div>

    </>
)

}
export default LotalyProgram